import ContentsTypes from "@shared/enums/contentsTypes";
import PrestationTemplate from "./PrestationTemplate";
import customTypes from "@project/enums/contentsCustomTypes.enum";
import { createPricingCardItem } from "../pricingCardItem";
import { createButton } from "../buttonWithArrow";
import { createDescriptionTabItem } from "../descriptionTabItem";
import { createColorImageBlock } from "../colorImageBlock";
import { createRowButtonItem } from "../home/home";
const createDynamiquePartDescriptionTabItem = (title, paragraph, subParagraph) => [
    {
        key: "dynamicElements",
        type: "TEXT",
        value: encodeURIComponent(`<p style="line-height:1.3;"><span style="color:hsl(240,5%,16%);font-size:20px;"><strong>${title}</strong></span></p><p style="line-height:1.3;">&nbsp;</p>`),
        children: [],
    },
    {
        key: "dynamicElements",
        type: "TEXT",
        value: paragraph,
        children: [],
    },
    {
        key: "dynamicElements",
        type: "SECTION",
        value: "",
        children: [
            {
                key: "dynamicPart",
                type: "DYNAMIC",
                value: "",
                children: [
                    {
                        key: "dynamicElements",
                        type: "TEXT",
                        value: encodeURIComponent(`<p style="line-height:1.6;"><span style="color:hsl(240,5%,16%);font-size:16px;"><strong>Ce que ça change pour vous</strong></span></p><p style="line-height:1.6;"><span style="font-size:16px;">${subParagraph}</span></p>`),
                        children: [],
                    },
                ],
            },
            {
                key: "size",
                type: "SELECT",
                value: "xl",
                children: [],
            },
            {
                key: "backgroundColor",
                type: "COLOR_EXTENDED",
                value: "#F6F6F9",
                children: [],
            },
            {
                key: "backgroundImage",
                type: "IMAGE_AS_FILE",
                value: "",
                children: [
                    {
                        key: "file",
                        type: "FILE_IMAGE",
                        value: "",
                        children: [],
                    },
                    {
                        key: "alt",
                        type: "INPUT",
                        value: "",
                        children: [],
                    },
                    {
                        key: "title",
                        type: "INPUT",
                        value: "",
                        children: [],
                    },
                ],
            },
        ],
    },
];
const createStepsRowItem = (steps, imageName, backgroundColor = "#F6F6F9", iconName = "back_office", lastStepBackgroundColor = "#F6F6F9") => ({
    key: "dynamicElements",
    type: "ROW",
    value: "",
    children: [
        {
            key: "items",
            type: "STEPS",
            value: "",
            children: [
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: "",
                            children: steps.map((step, index) => ({
                                key: "items",
                                type: "STEP",
                                value: "",
                                children: [
                                    {
                                        key: "title",
                                        type: ContentsTypes.INPUT,
                                        value: step.title,
                                    },
                                    {
                                        key: "description",
                                        type: ContentsTypes.INPUT,
                                        value: step.description,
                                    },
                                    {
                                        key: "borderColor",
                                        type: ContentsTypes.COLOR,
                                        value: step.borderColor,
                                    },
                                    {
                                        key: "backgroundColor",
                                        type: ContentsTypes.COLOR,
                                        value: step.backgroundColor ||
                                            (index === steps.length - 1
                                                ? lastStepBackgroundColor
                                                : ""),
                                    },
                                ],
                            })),
                        },
                    ],
                },
            ],
        },
        createColorImageBlock("130", "316", "446", imageName, backgroundColor, iconName, "#1C1C1E"),
        { key: "justifyContent", type: ContentsTypes.SELECT, value: "flex-start" },
        { key: "spacing", type: "SLIDER", value: "50" },
        { key: "columnOnMobile", type: "CHECKBOX", value: "false" },
        { key: "useFlexWrap", type: "CHECKBOX", value: "false" },
    ],
});
const createDescriptionCardWithLogoItem = (title, description, goal, imageId, imageName) => ({
    key: "dynamicElements",
    type: "DESCRIPTION_CARD_WITH_LOGO",
    value: "",
    children: [
        {
            key: "logo",
            type: ContentsTypes.IMAGE,
            value: "",
            children: [
                {
                    key: "file",
                    type: ContentsTypes.FILE_IMAGE,
                    value: JSON.stringify({
                        id: imageId,
                        name: imageName,
                        mimeType: "image/webp",
                        publicUrl: `/api/medias/${imageId}`,
                        url: `/api/medias/${imageId}`,
                        alt: "",
                        title: "",
                        position_ajustement: "contain",
                    }),
                },
                {
                    key: "alt",
                    type: ContentsTypes.INPUT,
                    value: "",
                },
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "",
                },
                {
                    key: "position_verticale",
                    type: ContentsTypes.SELECT,
                    value: "center",
                },
                {
                    key: "position_horizontale",
                    type: ContentsTypes.SELECT,
                    value: "center",
                },
                {
                    key: "position_ajustement",
                    type: ContentsTypes.SELECT,
                    value: "contain",
                },
                {
                    key: "filters",
                    type: "IMAGE_FILTERS",
                    value: "",
                    children: [
                        { key: "activated", type: "CHECKBOX", value: "false" },
                        { key: "opacity", type: "SLIDER", value: "1" },
                        { key: "blur", type: "SLIDER", value: "0" },
                        { key: "grayscale", type: "SLIDER", value: "0" },
                        { key: "brightness", type: "SLIDER", value: "1" },
                        { key: "saturate", type: "SLIDER", value: "1" },
                        { key: "sepia", type: "SLIDER", value: "0" },
                    ],
                },
            ],
        },
        {
            key: "title",
            type: ContentsTypes.INPUT,
            value: title,
        },
        {
            key: "description",
            type: ContentsTypes.SHORT_TEXT,
            value: description,
        },
        {
            key: "goal",
            type: ContentsTypes.INPUT,
            value: goal,
        },
    ],
});
export default {
    key: "PRESTATION_EXPERTES",
    label: "Prestation expertes",
    shortDescription: "Vous devez évaluer votre niveau de protection, construire votre résilience cyber, accompagner vos équipes ou être aidé en cas de crise ? Docaposte vous aide à qualifier vos besoins et à mobiliser les prestations expertes adaptées à votre contexte.",
    templateImage: "/template-prestation-expertes.png",
    Component: PrestationTemplate,
    initialContents: [
        {
            key: "title",
            type: ContentsTypes.TEXT,
            value: "%3Ch1%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3B%22%3EB%C3%A9n%C3%A9ficiez%20de%20l%27%3Cstrong%3Eaccompagnement%3C%2Fstrong%3E%20de%20nos%20experts%20pour%20renforcer%20votre%20cybers%C3%A9curit%C3%A9%3C%2Fspan%3E%3C%2Fh1%3E",
        },
        {
            key: "shortDescription",
            type: ContentsTypes.TEXT,
            value: "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3Bfont-size%3A16px%3B%22%3EVous%20devez%20%C3%A9valuer%20votre%20niveau%20de%20protection%2C%20construire%20votre%20r%C3%A9silience%20cyber%2C%20accompagner%20vos%20%C3%A9quipes%20ou%20%C3%AAtre%20aid%C3%A9%20en%20cas%20de%20crise%20%3F%20Docaposte%20vous%20aide%20%C3%A0%20qualifier%20vos%20besoins%20et%20%C3%A0%20mobiliser%20les%20prestations%20expertes%20adapt%C3%A9es%20%C3%A0%20votre%20contexte.%3C%2Fspan%3E%3C%2Fp%3E",
        },
        {
            key: "presentationDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "ROW",
                    value: "",
                    children: [
                        createRowButtonItem("Construire mon accompagnement", "contained"),
                        createRowButtonItem("Voir les orientations", "outlined"),
                        {
                            key: "justifyContent",
                            type: ContentsTypes.SELECT,
                            value: "flex-start",
                        },
                        { key: "spacing", type: "SLIDER", value: "24" },
                        { key: "columnOnMobile", type: "CHECKBOX", value: "true" },
                        {
                            key: "spacingMobile",
                            type: "SLIDER",
                            value: "16",
                        },
                    ],
                },
            ],
        },
        {
            key: "offerPresentationCard",
            type: customTypes.OFFER_PRESENTATION_CARD,
            value: "",
            children: [
                {
                    key: "barColor",
                    type: ContentsTypes.COLOR,
                    value: "#FFFF80",
                },
                {
                    key: "surtitle",
                    type: ContentsTypes.INPUT,
                    value: "Les prestations expertes",
                },
                {
                    key: "isPriceCard",
                    type: ContentsTypes.CHECKBOX,
                    value: "false",
                },
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: "4 orientations d’accompagnement",
                },
                {
                    key: "titleComplement",
                    type: ContentsTypes.INPUT,
                    value: "",
                },
                {
                    key: "features",
                    type: ContentsTypes.TEXT,
                    value: "<ul><li>Construire votre résilience cyber</li><li>Évaluer votre niveau de protection</li><li>Accompagner vos équipes par des experts</li><li>Être accompagné en cas de crise cyber</li></ul>",
                },
                {
                    key: "featuresOptional",
                    type: ContentsTypes.CHECKBOX,
                    value: "false",
                },
                {
                    key: "plusFeature",
                    type: ContentsTypes.INPUT,
                    value: "Audit, gouvernance, formation, intervention cadrés selon votre contexte.",
                },
            ],
        },
        {
            key: "titleExpertPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Nos accompagnements experts",
        },
        {
            key: "subtitleExpertPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "À chaque besoin cyber, une orientation d’accompagnement",
        },
        {
            key: "descriptionExpertPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Sélectionnez l'orientation qui correspond à votre situation pour découvrir les prestations associées et ce qu'elles changent pour votre organisation.",
        },
        {
            key: "dynamicExpertPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "DESCRIPTION_TABS",
                    value: "",
                    children: [
                        { key: "direction", type: "RADIO_GROUP", value: "vertical" },
                        { key: "style", type: "RADIO_GROUP", value: "text" },
                        { key: "color", type: "RADIO_GROUP", value: "secondary" },
                        {
                            key: "dynamicList",
                            type: ContentsTypes.DYNAMIC_LIST,
                            value: "",
                            children: [
                                {
                                    key: "contentType",
                                    value: "DESCRIPTION_TABS_ITEM",
                                    children: [
                                        createDescriptionTabItem("Construire votre résilience cyber", "", "true", "#ffffff", "#0CFFC6", createDynamiquePartDescriptionTabItem("Construire votre résilience cyber", "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EStructurer%20une%20trajectoire%20cyber%2C%20organiser%20les%20travaux%20%C3%A0%20mener%20et%20piloter%20leur%20mise%20en%20%C5%93uvre.%3C%2Fspan%3E%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%26nbsp%3B%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EPrestations%20associ%C3%A9es%20%3A%3C%2Fspan%3E%3C%2Fp%3E%3Cul%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ec701a5e587710ec64f3bf73e7b590af8%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EAccompagnement%20RSSI%20%26amp%3B%20PMO.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ebf08bee7d3152f9d9a766f004c1112ba%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EConstruction%20de%20feuille%20de%20route%20projet.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ed4f5dd3994ed4045b79f1c199a65b376%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EIng%C3%A9nierie%20documentaire%20et%20politiques%20de%20s%C3%A9curit%C3%A9.%3C%2Fspan%3E%3C%2Fli%3E%3C%2Ful%3E", "Vous avancez avec une gouvernance cyber plus lisible, même sans expertise dédiée en interne.")),
                                        createDescriptionTabItem("Évaluer votre niveau de protection", "", "true", "#ffffff", "#BF7CFF", createDynamiquePartDescriptionTabItem("Évaluer votre niveau de protection", "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EComprendre%20rapidement%20vos%20vuln%C3%A9rabilit%C3%A9s%2C%20votre%20niveau%20de%20maturit%C3%A9%20et%20les%20priorit%C3%A9s%20%C3%A0%20traiter.%3C%2Fspan%3E%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%26nbsp%3B%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EPrestations%20associ%C3%A9es%20%3A%3C%2Fspan%3E%3C%2Fp%3E%3Cul%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ec701a5e587710ec64f3bf73e7b590af8%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EDiagnostic%20rapide%20%3A%20en%202h%20avec%20outils%20automatiques%20de%20scan%2C%20entretien%20avec%20nos%20experts%20et%20rapport%20de%20synth%C3%A8se.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ebf08bee7d3152f9d9a766f004c1112ba%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EDiagnostic%20avanc%C3%A9%20%3A%20en%202%20jours%20avec%20scan%20externe%2C%20analyse%20interne%20(Cartographie%2C%20analyse%20AD)%2C%20analyse%20de%20maturit%C3%A9%2C%20rapport%20de%20synth%C3%A8se.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ed4f5dd3994ed4045b79f1c199a65b376%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EPentest%20%3A%20test%20d'intrusion%20sur%20vos%20syst%C3%A8mes%20par%20nos%20experts%20certifi%C3%A9s.%3C%2Fspan%3E%3C%2Fli%3E%3C%2Ful%3E", "Vous disposez d'une vision claire de vos risques et d'un plan d'action priorisé.")),
                                        createDescriptionTabItem("Accompagner vos équipes", "", "true", "#ffffff", "#FFFF80", createDynamiquePartDescriptionTabItem("Accompagner vos équipes par des experts cyber", "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3ESensibiliser%2C%20former%20et%20faire%20monter%20en%20comp%C3%A9tence%20les%20personnes%20cl%C3%A9s%20de%20votre%20organisation.%3C%2Fspan%3E%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%26nbsp%3B%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EPrestations%20associ%C3%A9es%20%3A%3C%2Fspan%3E%3C%2Fp%3E%3Cul%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ec701a5e587710ec64f3bf73e7b590af8%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EFormations%20g%C3%A9n%C3%A9ralistes%20et%20sp%C3%A9cialis%C3%A9es.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ebf08bee7d3152f9d9a766f004c1112ba%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EParcours%20pour%20DSI%2C%20DSSI%2C%20dirigeants%2C%20chefs%20de%20projet%20et%20%C3%A9quipes%20internes.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ed4f5dd3994ed4045b79f1c199a65b376%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EExercice%20de%20prise%20de%20conscience%20sur%20la%20base%20d'une%20simulation%20de%20crise.%3C%2Fspan%3E%3C%2Fli%3E%3C%2Ful%3E", "Vos équipes comprennent mieux les risques, adoptent les bons réflexes et savent mieux réagir.")),
                                        createDescriptionTabItem("Être accompagné en cas de crise", "", "true", "#ffffff", "#FF5657", createDynamiquePartDescriptionTabItem("Être accompagné en cas de crise cyber", "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EComprendre%20rapidement%20vos%20vuln%C3%A9rabilit%C3%A9s%2C%20votre%20niveau%20de%20maturit%C3%A9%20et%20les%20priorit%C3%A9s%20%C3%A0%20traiter.%3C%2Fspan%3E%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%26nbsp%3B%3C%2Fp%3E%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EPrestations%20associ%C3%A9es%20%3A%3C%2Fspan%3E%3C%2Fp%3E%3Cul%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ec701a5e587710ec64f3bf73e7b590af8%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EForce%20d'intervention%20rapide.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ebf08bee7d3152f9d9a766f004c1112ba%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EAssistance%20experte%20en%20cas%20de%20crise.%3C%2Fspan%3E%3C%2Fli%3E%3Cli%20class%3D%22ck-list-marker-font-size%22%20style%3D%22--ck-content-list-marker-font-size%3A16px%3B%22%20data-list-item-id%3D%22ed4f5dd3994ed4045b79f1c199a65b376%22%3E%3Cspan%20style%3D%22font-size%3A16px%3B%22%3EAppui%20%C3%A0%20la%20qualification%20et%20%C3%A0%20la%20coordination%20des%20premi%C3%A8res%20actions.%3C%2Fspan%3E%3C%2Fli%3E%3C%2Ful%3E", "Vous êtes guidé dans les moments critiques pour limiter l'impact opérationnel et sécuriser la reprise.")),
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titleStepPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Les étapes de votre accompagnement",
        },
        {
            key: "subtitleStepPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Comment se construit votre accompagnement ?",
        },
        {
            key: "descriptionStepPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "De la description de votre besoin à la réponse cadrée, un parcours simple, mené avec nos experts.",
        },
        {
            key: "dynamicStepPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createStepsRowItem([
                    {
                        title: "Vous décrivez votre besoin",
                        description: "Contexte, périmètre, enjeux, contraintes techniques ou réglementaires : vous nous partagez votre situation et vos priorités.",
                        borderColor: "#FFFF80",
                    },
                    {
                        title: "Nos experts qualifient la demande",
                        description: "Un entretien technique permet de préciser le besoin, d'identifier les risques et de vérifier le type d'accompagnement le plus pertinent.",
                        borderColor: "#BF7CFF",
                    },
                    {
                        title: "Nous construisons la réponse adaptée",
                        description: "Prestation ponctuelle, accompagnement RSSI/PMO, formation, exercice, intervention ou combinaison de modules : l'accompagnement est cadré sur devis.",
                        borderColor: "#FFFF80",
                    },
                ], "f10a2c4ff54c5cbafa29e845d3aa741ad42bd4be.webp", "#F6F6F9", "back_office"),
            ],
        },
        {
            key: "dynamicBadgePart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createDescriptionCardWithLogoItem("Docaposte, un tiers de confiance pour vos enjeux cyber avancés", "Avec Docaposte, vous bénéficiez d'un accompagnement porté par un acteur souverain de confiance, capable de mobiliser des expertises techniques, de conseil et de gouvernance pour sécuriser votre trajectoire cyber.", "L’objectif : rendre vos décisions plus lisibles, vos actions plus prioritaires et votre activité plus résiliente.", "", "tech_and_trust_docaposte 2.webp"),
            ],
        },
        {
            key: "titleContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Votre besoin est plus spécifique ? Parlons-en",
        },
        {
            key: "descriptionContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Partagez-nous votre situation : nos experts vous aideront à clarifier le périmètre et à construire une réponse adaptée.",
        },
        {
            key: "dynamicContactPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [createButton("Être rappelé par un expert", "contact")],
        },
        {
            key: "titleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Aller plus loin",
        },
        {
            key: "subtitleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Poursuivez votre parcours selon votre besoin",
        },
        {
            key: "dynamicFurtherPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        createPricingCardItem("default", "M", "#0CFFC6", "TPE, petite PME, petite collectivités", "Découvrir le pack cyber", "Pour les petites structures qui souhaitent une offre packagée, lisible et accompagnée pour protéger l’essentiel.", "", "", "", "", "", "", "/pack-cyber", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("default", "M", "#BF7CFF", "PME, collectivités moyenne", "Explorer les modules outils", "Pour compléter votre protection avec des modules adaptés à vos risques prioritaires.", "", "", "", "", "", "", "/modules-outils", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("highlighted", "M", "#0000FF", "", "Revenir à l'accueil de l'offre Cyber", "Pour retrouver une vue d'ensemble de nos solutions cyber.", "", "", "", "", "", "", "/", "Revenir", "long-arrow-right"),
                        { key: "size", type: "SELECT_GRID", value: "4" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "12" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "48" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
    ],
};
